<template>
    <g fill="none" fill-rule="evenodd" opacity=".6">
        <path fill="#FFC43C" d="M0 9c0-4.97 4.037-9 9.002-9h21.996A9 9 0 0 1 40 9c0 4.97-4.037 9-9.002 9H9.002A9 9 0 0 1 0 9z"/>
        <path fill="#FFF" fill-rule="nonzero" d="M16.972 12.958l-2.56-8.24c-.17-.53-.87-.718-1.419-.718s-1.25.188-1.418.718L9.028 12.96c-.014.055-.028.11-.028.154 0 .491.762.887 1.392.887.394 0 .643-.141.72-.408l.461-1.672h2.854l.461 1.672c.077.267.326.408.72.408.63 0 1.392-.396 1.392-.887 0-.044-.014-.1-.028-.155zm-4.948-2.704l.97-3.512.969 3.512h-1.94z"/>
        <circle cx="31" cy="9" r="8" fill="#FFF"/>
    </g>
</template>

<script>
export default {
    name: 'switcherADisabledIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 40 18');
    }
};
</script>
